/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ArchitectureTypesEnum } from './ArchitectureTypesEnum';
import {
    ArchitectureTypesEnumFromJSON,
    ArchitectureTypesEnumFromJSONTyped,
    ArchitectureTypesEnumToJSON,
} from './ArchitectureTypesEnum';

/**
 * 
 * @export
 * @interface ErroredPackageSchema
 */
export interface ErroredPackageSchema {
    /**
     * 
     * @type {string}
     * @memberof ErroredPackageSchema
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ErroredPackageSchema
     */
    specifier: string;
    /**
     * 
     * @type {string}
     * @memberof ErroredPackageSchema
     */
    source: ErroredPackageSchemaSourceEnum;
    /**
     * 
     * @type {string}
     * @memberof ErroredPackageSchema
     */
    condaName?: string;
    /**
     * 
     * @type {string}
     * @memberof ErroredPackageSchema
     */
    error?: string;
    /**
     * 
     * @type {ArchitectureTypesEnum}
     * @memberof ErroredPackageSchema
     */
    architecture: ArchitectureTypesEnum;
}


/**
 * @export
 */
export const ErroredPackageSchemaSourceEnum = {
    Conda: 'conda',
    Pip: 'pip'
} as const;
export type ErroredPackageSchemaSourceEnum = typeof ErroredPackageSchemaSourceEnum[keyof typeof ErroredPackageSchemaSourceEnum];


/**
 * Check if a given object implements the ErroredPackageSchema interface.
 */
export function instanceOfErroredPackageSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "specifier" in value;
    isInstance = isInstance && "source" in value;
    isInstance = isInstance && "architecture" in value;

    return isInstance;
}

export function ErroredPackageSchemaFromJSON(json: any): ErroredPackageSchema {
    return ErroredPackageSchemaFromJSONTyped(json, false);
}

export function ErroredPackageSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): ErroredPackageSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'specifier': json['specifier'],
        'source': json['source'],
        'condaName': !exists(json, 'conda_name') ? undefined : json['conda_name'],
        'error': !exists(json, 'error') ? undefined : json['error'],
        'architecture': ArchitectureTypesEnumFromJSON(json['architecture']),
    };
}

export function ErroredPackageSchemaToJSON(value?: ErroredPackageSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'specifier': value.specifier,
        'source': value.source,
        'conda_name': value.condaName,
        'error': value.error,
        'architecture': ArchitectureTypesEnumToJSON(value.architecture),
    };
}

